import React, { useCallback, useEffect } from "react";
import { Remarkable } from "remarkable";

/**
 * 
 * @param {*} markdown 
 * @returns 
 */
export const useRemarkable = (markdown) => {
    const [html, setHtml] = React.useState(null);
    const createMarkup = useCallback((_markdown) => {
      const md = new Remarkable("full",{
        html: true, // Permite HTML (por si deseas usar etiquetas HTML dentro del markdown)
        breaks: true, // Permite que los saltos de línea sean procesados como <br>
        typographer: true, // Mejora las comillas y otros símbolos tipográficos  
      });
      const rawMarkup = md.render(_markdown);
      return { __html: rawMarkup };
    }, []);

    useEffect(() => {
        setHtml(createMarkup(markdown));
      }, [markdown,createMarkup]);
    return {html,createMarkup}
}